import { useEffect } from "react";
import { Form, Input, Select, Row, Col, Tooltip, Divider } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";

export default function PricingInformationForm({
  onFinish,
  form,
  initialValues,
  QuotationType,
  marketType,
  valuationApproach,
  productCodes
}) {
  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);

  return (
    <div>
      <h3 style={{ marginBottom: "24px", fontWeight: "600" }}>
        Pricing Information
      </h3>

      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        initialValues={initialValues}
      >
        {/* Pricing Information Section */}
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Quotation Type
                  <Tooltip title="Method by which the security is quoted in the market.">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="quotationTypeId"
              rules={[
                { required: true, message: "Please select quotation type" },
              ]}
            >
              <Select
                placeholder="Select quotation type"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              >
                {QuotationType.map((quotation) => (
                  <Select.Option key={quotation.value} value={quotation.value}>
                    {quotation.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Market Type
                  <Tooltip title="Market in which the security is traded.">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="marketTypeId"
              rules={[{ required: true, message: "Please select market type" }]}
            >
              <Select
                placeholder="Select market type"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              >
                {marketType.map((market) => (
                  <Select.Option key={market.value} value={market.value}>
                    {market.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Decimal Place
                  <Tooltip title="Number of decimal places allowed for pricing or yield.">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="ticketSize"
              rules={[
                {
                  required: true,
                  message: "Please enter tick size / price precision",
                },
              ]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="e.g., 2, 4, 6 (decimal places)"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Valuation Approach
                  <Tooltip title="Method used to value the security for accounting and reporting.">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="valuationApproachId"
              rules={[
                { required: true, message: "Please select valuation approach" },
              ]}
            >
              <Select
                placeholder="Select valuation approach"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              >
                {valuationApproach.map((valuationApproach) => (
                  <Select.Option
                    key={valuationApproach.value}
                    value={valuationApproach.value}
                  >
                    {valuationApproach.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* <Row style={{ marginTop: "12px" }}>
          <Col span={24}>
            <div
              style={{
                backgroundColor: "#f5f5f5",
                padding: "12px",
                borderRadius: "4px",
                fontSize: "12px",
                color: "#666",
              }}
            >
              <strong>Note:</strong> This ensures correct pricing and valuation.
            </div>
          </Col>
        </Row> */}

        <Divider style={{ margin: "24px 0" }} />

        {/* Behavioral Link to Product Section */}
        <h4 style={{ marginBottom: "16px", fontWeight: "600" }}>
          Behavioural Link to Product (MANDATORY)
        </h4>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Product Code
                  <Tooltip title="Reference to the Treasury Product that governs the security’s behaviour.">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="linkedProductId"
              rules={[
                {
                  required: true,
                  message:
                    "Please select product code (determines pricing engine, accounting, lifecycle, accrual rules)",
                },
              ]}
            >
              <Select
                placeholder="Select product code"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                showSearch
                optionFilterProp="label"
              >
                {productCodes.map((prod) => (
                  <Select.Option
                    key={prod.value}
                    value={prod.value}
                    label={prod.label}
                  >
                    {prod.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ marginTop: "12px" }}>
          <Col span={24}>
            <div
              style={{
                backgroundColor: "#f5f5f5",
                padding: "12px",
                borderRadius: "4px",
                fontSize: "12px",
                color: "#666",
              }}
            >
              <strong>Note:</strong> This is CRITICAL because the Security
              Master does NOT carry behaviour — only attributes. Behaviour comes
              from the Product.
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
}
